var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"99cac29db0563a19a8f3e6c658901680b84e51e1"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import { isPrivateCapabilityPath } from "@/lib/booking/sharedBooking";
import * as Sentry from "@sentry/nextjs";
import { captureWhatsAppLink } from "@/lib/whatsappLinkContext";

captureWhatsAppLink();

Sentry.init({
  dsn: "https://e00f037e168c971f20d88f13a20f85e0@o4505896418344960.ingest.us.sentry.io/4506955076009984",

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
  autoSessionTracking: false, // Disables session cookies
  tracesSampleRate: 0, // Disables transaction SAMPLING (no spans sent to Sentry). Note: this does NOT disable
  // outbound trace propagation — @sentry/nextjs still injects sentry-trace + baggage + W3C traceparent
  // headers on fetch/XHR calls. Set tracePropagationTargets: [] to kill propagation entirely.

  enabled: process.env.NEXT_PUBLIC_ENVIRONMENT === "production",

  denyUrls: [/\/ingest\/static\//, /posthog\.com/],

  ignoreErrors: [
    "Team ID is not known",
    "undefined is not an object (evaluating 'window.webkit.messageHandlers')",
    "The WKWebView was deallocated before the message was delivered",
    /downProgCallback is not defined/,
    "syncDownloadState is not defined",
    "Called on script loaded before session recording is available",
    "Cannot use import statement outside a module",
  ],

  beforeSend(event) {
    if (
      typeof window !== "undefined" &&
      isPrivateCapabilityPath(window.location.pathname)
    )
      return null;
    const frames = event.exception?.values?.[0]?.stacktrace?.frames;
    if (frames?.some((frame) => frame.filename?.includes("/ingest/static/"))) {
      return null;
    }
    return event;
  },
  beforeBreadcrumb(breadcrumb) {
    if (breadcrumb.data?.url?.includes("/api/messaging/whatsapp/")) return null;
    if (
      typeof window !== "undefined" &&
      isPrivateCapabilityPath(window.location.pathname)
    )
      return null;
    return breadcrumb;
  },
});
